module.exports = __webpack_public_path__ + "static/media/iphone3-6.e16386ca.png";